// RefName: *
export const ContentIDConstants = {
  MainHeader: 0,
  MainSummary: 1,
  MainButton: 2,
  ModuleEstimate: 3,
};
